import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { X } from 'lucide-react';
const modalContent: Record<string, {
  title: string;
  body: React.ReactNode;
}> = {
  privacy: {
    title: 'Privacy Policy',
    body: <div className="space-y-4 text-stone-300 text-sm leading-relaxed" data-id="element-100">
        <p data-id="element-101">
          <strong className="text-white" data-id="element-102">Last Updated:</strong> January 2026
        </p>
        <p data-id="element-103">
          Your privacy is important to us. This Privacy Policy explains how we
          collect, use, and protect your personal information when you visit our
          website or purchase our products.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-104">
          Information We Collect
        </h3>
        <p data-id="element-105">
          We collect only the information necessary to process your order,
          including your name and payment details through our secure third-party
          payment processor. We do not store credit card information on our
          servers.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-106">
          How We Use Your Information
        </h3>
        <p data-id="element-107">
          Your information is used solely to deliver your digital product and
          provide customer support. We do not sell, rent, or share your personal
          information with third parties for marketing purposes.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-108">Cookies</h3>
        <p data-id="element-109">
          Our website may use cookies to improve your browsing experience. You
          can disable cookies in your browser settings at any time.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-110">Data Security</h3>
        <p data-id="element-111">
          We implement industry-standard security measures to protect your
          personal information from unauthorized access, alteration, or
          disclosure.
        </p>
      </div>
  },
  terms: {
    title: 'Terms of Service',
    body: <div className="space-y-4 text-stone-300 text-sm leading-relaxed" data-id="element-112">
        <p data-id="element-113">
          <strong className="text-white" data-id="element-114">Last Updated:</strong> January 2026
        </p>
        <p data-id="element-115">
          By purchasing and using "The Golden Root Ritual," you agree to the
          following terms and conditions.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-116">Digital Product</h3>
        <p data-id="element-117">
          This is a digital product delivered in PDF format. Upon successful
          payment, you will receive instant access to download the guide. Due to
          the digital nature of this product, all sales are final except as
          outlined in our refund policy.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-118">Refund Policy</h3>
        <p data-id="element-119">
          We offer a 7-day money-back guarantee. If you are not satisfied with
          the product within 7 days of purchase, you may request a full
          refund—no questions asked.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-120">Disclaimer</h3>
        <p data-id="element-121">
          The information provided in this guide is for educational and
          informational purposes only. It is not intended as a substitute for
          professional medical advice, diagnosis, or treatment. Always consult
          your physician before starting any new health regimen.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-122">
          Intellectual Property
        </h3>
        <p data-id="element-123">
          All content within "The Golden Root Ritual" is protected by copyright.
          You may not reproduce, distribute, or resell any part of this product
          without written permission.
        </p>
      </div>
  },
  support: {
    title: 'Contact Support',
    body: <div className="space-y-4 text-stone-300 text-sm leading-relaxed" data-id="element-124">
        <p data-id="element-125">
          We're here to help! If you have any questions about your order, the
          product, or need assistance, please reach out through the following
          channels:
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-126">
          Customer Support
        </h3>
        <p data-id="element-127">
          For order inquiries, refund requests, or product questions, please use
          the support form available on our main website. Our team typically
          responds within 24–48 business hours.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-128">
          Technical Issues
        </h3>
        <p data-id="element-129">
          If you're having trouble downloading your PDF or accessing your
          purchase, please clear your browser cache and try again. If the issue
          persists, reach out to our support team and we'll get it resolved
          promptly.
        </p>
        <h3 className="text-white font-bold text-base mt-6" data-id="element-130">Business Hours</h3>
        <p data-id="element-131">
          Monday – Friday, 9:00 AM – 5:00 PM (EST). We do our best to respond to
          all inquiries as quickly as possible.
        </p>
      </div>
  }
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  return <footer className="bg-stone-900 text-white py-16" data-id="element-132">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-133">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif text-amber-500" data-id="element-134">
          Stop Fighting Your Body. Start Working With It.
        </h2>

        <p className="text-xl text-stone-300 mb-10 max-w-2xl mx-auto" data-id="element-135">
          Join thousands of women who have replaced the "bloat" with "glow."
        </p>

        <div className="mb-16" data-id="element-136">
          <Button size="xl" className="shadow-amber-900/50" data-id="element-137">
            I WANT MY FLAT BELLY BACK →
          </Button>
        </div>

        <div className="border-t border-stone-800 pt-8 text-stone-500 text-sm" data-id="element-138">
          <div className="flex flex-col md:flex-row justify-center gap-6 mb-4" data-id="element-139">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-amber-500 transition-colors cursor-pointer" data-id="element-140">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-amber-500 transition-colors cursor-pointer" data-id="element-141">
              Terms of Service
            </button>
            <button onClick={() => setActiveModal('support')} className="hover:text-amber-500 transition-colors cursor-pointer" data-id="element-142">
              Contact Support
            </button>
          </div>
          <p data-id="element-143">
            © {new Date().getFullYear()} The Golden Root Ritual. All rights
            reserved.
          </p>
          <p className="mt-2 text-xs max-w-2xl mx-auto" data-id="element-144">
            Disclaimer: The content of this site is for informational purposes
            only, and is not intended to replace professional medical advice,
            diagnosis or treatment. Always seek the advice of your physician or
            other qualified health provider with any questions you may have
            regarding a medical condition.
          </p>
        </div>
      </div>

      {/* Modal */}
      {activeModal && modalContent[activeModal] && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-145">
          <div className="bg-stone-800 rounded-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto shadow-2xl border border-stone-700" onClick={e => e.stopPropagation()} data-id="element-146">
            <div className="flex items-center justify-between p-6 border-b border-stone-700 sticky top-0 bg-stone-800 rounded-t-2xl" data-id="element-147">
              <h3 className="text-xl font-bold text-amber-500 font-serif" data-id="element-148">
                {modalContent[activeModal].title}
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-stone-700 transition-colors cursor-pointer" data-id="element-149">
                <X className="w-5 h-5 text-stone-400" data-id="element-150" />
              </button>
            </div>
            <div className="p-6" data-id="element-151">{modalContent[activeModal].body}</div>
          </div>
        </div>}
    </footer>;
}